import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ReportDownloadsTable from "@/components/superadmin/ReportDownloadsTable";
import ReportVersionsManager from "@/components/superadmin/ReportVersionsManager";

type ReportsTab = "downloads" | "versions";

const SuperadminReports = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get("tab");
  const activeTab: ReportsTab = rawTab === "versions" ? "versions" : "downloads";

  const handleTabChange = (value: string) => {
    const nextTab: ReportsTab = value === "versions" ? "versions" : "downloads";
    setSearchParams({ tab: nextTab });
  };

  return (
    <div className="flex flex-col h-full bg-white rounded-lg p-5 shadow-sm border border-gray-200">
      <div className="flex-shrink-0 mb-6">
        <h2 className="text-xl font-bold tracking-tight">Reports</h2>
        <p className="text-muted-foreground">
          Manage report versions and review download activity.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={handleTabChange} className="flex flex-col flex-1 min-h-0">
        <TabsList className="w-fit">
          <TabsTrigger value="downloads">Downloads</TabsTrigger>
          <TabsTrigger value="versions">Versions</TabsTrigger>
        </TabsList>

        <TabsContent
          value="downloads"
          className="mt-4 flex flex-col data-[state=active]:flex-1 data-[state=active]:min-h-0"
        >
          <div className="flex-1 min-h-0">
            <ReportDownloadsTable />
          </div>
        </TabsContent>

        <TabsContent
          value="versions"
          className="mt-4 flex flex-col data-[state=active]:flex-1 data-[state=active]:min-h-0"
        >
          <div className="flex-1 min-h-0 overflow-auto pr-1">
            <ReportVersionsManager />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SuperadminReports;
